/* eslint-disable no-unused-vars */
import React, {
  Component,
  useContext,
  useRef,
  useCallback,
  useEffect,
  useState,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */
import NpsEmbedded from '../../nps/NpsEmbedded';
import sendRAT, { ACTION, SCREEN } from '../../../../../phase2/survey/app/rat';
import { Broadcast, Init } from '../../../../broadcast';

/**
 * embedded Nps - generator UI(onChange) と棲み分けるために callback が変更可能になっています
 * - {@link NpsEmbedded}
 * @param {*} state {@link survey}.Context.state
 * @param {boolean} desktop - resize desktop flag
 * @param {*} nps Redux.store.nps - Nps 状態を保持します
 * @return {boolean|*} React.node - checked 後に非表示になります
 * @constructor
 */
const WidgetEmbeddedNps = ({ state, desktop, nps }) => {
  const [show, setShow] = useState(true);
  const [disabled, setDisabled] = useState(false);

  const onceRef = useRef(false);

  useEffect(() => {
    // if (desktop && !onceRef.current && !nps.meta.appear) {
    // desktop / mobile 双方埋め込む
    if (!onceRef.current && !nps.meta.appear) {
      onceRef.current = true;
      // RAT for appear
      sendRAT({
        cId: state.config.cId.value,
        screen: SCREEN.NPS,
        action: ACTION.APPEAR,
      });
      // ---
      Broadcast.nps.appear();
      setTimeout(Init.nps, 16);
    }
  }, [onceRef, nps, state, desktop]);

  const onChange = useCallback(
    event => {
      const { target } = event;
      // const value = parseInt(target.dataset.index, 10);
      // sendRAT - cId, screen: SCREEN.NPS `nps`, action: ACTION.ANSWER `answer`
      sendRAT({
        cId: state.config.cId.value,
        screen: SCREEN.NPS,
        action: ACTION.ANSWER,
      });
      // // Redux dispatch
      // Broadcast.nps.change({
      //   checked: parseInt(target.dataset.index, 10),
      //   name: target.name,
      //   value: target.value,
      // });
      // nps disabled
      setDisabled(true);
      // // hide Nps
      // setShow(false);
      // @since 20200127 delay hide nps
      setTimeout(() => {
        // Redux dispatch
        Broadcast.nps.change({
          checked: parseInt(target.dataset.index, 10),
          name: target.name,
          value: target.value,
        });
        setShow(false);
      }, 100);
    },
    [state, setShow, setDisabled]
  );
  // console.log('WidgetEmbeddedNps - show', show);
  return (
    // nps check 後は表示しない
    show && (
      <NpsEmbedded
        message={state.config.nps.question.label}
        minScoreLabel={state.config.nps.txt0}
        maxScoreLabel={state.config.nps.txt1}
        name={state.config.nps.options[0].name}
        optionValues={state.config.nps.options}
        onChange={onChange}
        desktop={desktop}
        state={state}
        nps={nps}
        disabled={disabled}
      />
    )
  );
};

export default WidgetEmbeddedNps;



// WEBPACK FOOTER //
// ./src/embedded-type/survey/page/widget/sequence/WidgetEmbeddedNps.js